export default "__VITE_ASSET__T9NhwSKc__"